// BaseList.jsx

import React from 'react';

// Services
import { getBaseKey } from 'services/bases/BaseReadService';

// Hooks
import useBaseExpiredBadges from 'hooks/useBaseExpiredBadges';

// CSS
import './BaseList.css';

// Components
import Divider from 'components/divider/Divider';
import AddBaseButton from 'main/sidebar/switcher/popup/addbase/AddBaseButton';
import BaseButton from 'main/sidebar/switcher/popup/baselist/button/BaseButton';

/**
 * BaseList
 * 
 * Renders the list of bases in the sidebar switcher popup.
 *  
 *
 * @returns {ReactNode} - BaseList.
 */
const BaseList = React.memo(({
    onSelect,
    onAdd,
    bases = [],
    activeBaseKey = null,
}) => {

    // ----- HOOKS ----- //

    const expiredByKey = useBaseExpiredBadges(bases);
    // ----- RENDER ----- //

    return (

        <div className="base-list-container">

            {/* BUTTONS */}
            <div className="base-list-buttons">

                {bases.map((base) => {
                    const baseKey = getBaseKey(base);
                    const isExpired = baseKey ? expiredByKey.get(baseKey) === true : false;

                    return (
                        <BaseButton
                          key={getBaseKey(base) || String(base?.title || '')}
                          base={base}
                          isActive={Boolean(activeBaseKey && (getBaseKey(base) === activeBaseKey))}
                          isExpired={isExpired}
                          onClick={() => onSelect(base)}
                        />
                    );
                })}

            </div>

            <Divider />

            <AddBaseButton
                onClick={onAdd}
            />

        </div>
    );

});

// Dev Tools
BaseList.displayName = 'BaseList';

export default BaseList;
